import React from 'react';
import Select from 'react-select';
import axios from 'axios';

import {
	getSession,
} from 'Vulture/Session';

import CustomIcon from '../Common/CustomIcon/CustomIcon.js';

import style from './Billing.module.css';

class BillingView extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedProperty:     null,
			activeTab:            'billing information',
			projectNumbers:       [],
			projectNumbersLoaded: false,
			propertyInvoices:     [],
			fetchingError:        false,
			missingCustomerId:    false,
			formData:             {
				company_name: '',
				contact:      '',
				email:        '',
				phone:        '',
				addr1:        '',
				addr2:        '',
				city:         '',
				state:        '',
				zip_code:     '',
			},
			originalBillingData:  {
				company_name: '',
				contact:      '',
				email:        '',
				phone:        '',
				addr1:        '',
				addr2:        '',
				city:         '',
				state:        '',
				zip_code:     '',
			},
			customerID:   '',
			customerName: '',
			errors:       {},
			isEditing:    false,
		};
	}

	componentDidMount() {
		if (this.props.fd && !this.state.projectNumbersLoaded) {
			this.getProjectNumbers();
		}
	}

	componentDidUpdate = (prevProps, prevState) => {
		if (prevState.selectedProperty !== this.state.selectedProperty) {
			this.getInvoices();
		}

		if (this.props.fd && prevProps.fd !== this.props.fd && !this.state.projectNumbersLoaded) {
			this.getProjectNumbers();
		}
	}

	getProjectNumbers = () => {
		// const url = new URL(window.location.href);
		// const segments = url.pathname.split('/');

		// const accountUUID = segments[segments.length - 1] || segments[segments.length - 2];

		// if (!accountUUID) {
		// 	console.error('Account UUID not found in the URL.');
		// 	return;
		// }

		const {
			fd,
			accountUUID,
			permissions,
		} = this.props;

		const account = fd[`account.${accountUUID}`];
		let projectNumbers = [];

		if (account) {
			for (const [ m1Key, m1Data, ] of Object.entries(account)) {
				if (m1Key.startsWith('system_group.')) {
					if (!permissions?.access_limits?.property_limited ||
						permissions.accessible_data.properties.includes(m1Key.replace('system_group.', ''))) {
						const projectNumber = fd[m1Key]?.project_number;
						if (projectNumber) {
							projectNumbers.push({
								projectNumber,
								systemGroupName: fd[m1Key].display_name,
							});
						}
					}
				}
			}

			this.setState({
				projectNumbers,
				projectNumbersLoaded: true,
			});
		} else {
			console.warn(`No account found for UUID: ${accountUUID}`);
		}
	}

	getBillingInformation = async (selectedProperty) => {
		const {
			app,
			fd,
		} = this.props;

		const session = getSession();
		let salesforceIdVal;

		for (const [ m1Key, m1Data, ] of Object.entries(fd)) {
			if (m1Key.startsWith('system_group.')) {
				if (m1Data.project_number === selectedProperty) {
					salesforceIdVal = m1Data.salesforce_id_val;
				}
			}
		}

		app.load(async () => {
			const broncoURL = window._getEnv('BRONCO_URL');

			const fetchBillingInformation = async (selectedProperty, id) => {
				try {
					const url = `${broncoURL}/system_group/${selectedProperty}/maxio`;
					const headers = {
						'X-Auth-Session': session.session,
					};

					const response = await axios.get(url, {
						headers,
					});
					const data = response.data;

					const billingData = {
						company_name: data.billing_profile.company_name || '',
						contact:      data.billing_profile.contact || '',
						email:        data.billing_profile.email || '',
						phone:        data.billing_profile.phone || '',
						addr1:        data.billing_profile.addr1 || '',
						addr2:        data.billing_profile.addr2 || '',
						city:         data.billing_profile.city || '',
						state:        data.billing_profile.state || '',
						zip_code:     data.billing_profile.zip_code || '',
					};

					// Update both formData and originalBillingData with the fetched data
					this.setState({
						formData:            { ...billingData },
						originalBillingData: { ...billingData },
						customerID:          data.id,
						customerName:        data.name,
						errors:              {},
					});
				} catch (err) {
					const emptyData = {
						company_name: '',
						contact:      '',
						email:        '',
						phone:        '',
						addr1:        '',
						addr2:        '',
						city:         '',
						state:        '',
						zip_code:     '',
					};
					this.setState({
						formData:            { ...emptyData },
						originalBillingData: { ...emptyData },
						customerID:          '',
						customerName:        '',
						errors:              {},
					});
					console.error('Error fetching billing information:', err);
				}
			};

			await fetchBillingInformation(selectedProperty, salesforceIdVal);
		});
	}

	updateBillingInformation = async (selectedProperty) => {
		const {
			app,
		} = this.props;

		const session = getSession();
		const broncoURL = window._getEnv('BRONCO_URL');

		// Retrieve form data from state
		const {
			company_name,
			contact,
			email,
			phone,
			addr1,
			addr2,
			city,
			state,
			zip_code,
		} = this.state.formData;

		app.load(async () => {
			try {
				const url = `${broncoURL}/system_group/${selectedProperty}/maxio`;
				const headers = {
					'X-Auth-Session': session.session,
					'Content-Type':   'application/json',
				};

				const payload = {
					id:              Number(this.state.customerID),
					name:            this.state.customerName,
					billing_profile: {
						company_name,
						contact,
						email,
						phone,
						addr1,
						addr2,
						city,
						state,
						zip_code,
						salutation: selectedProperty,
					},
				};

				const response = await axios.patch(url, payload, {
					headers,
				});
				console.log('Billing information updated successfully:', response.data);
			} catch (err) {
				console.error('Error updating billing information:', err);
			}
		});
	};

	getInvoices = () => {
		const {
			app,
		} = this.props;

		app.load(async () => {
			const broncoURL = window._getEnv('BRONCO_URL');

			const fetchInvoiceInfomation = async (propertyNumber) => {
				const url = `${broncoURL}/system_group/${propertyNumber}/maxio/invoices`;
				const session = getSession();
				const headers = {
					'X-Auth-Session': session.session,
				};

				try {
					const response = await axios.get(url, {
						headers,
					});
					this.setState({
						propertyInvoices:  response.data,
						fetchingError:     false,
						missingCustomerId: false,
					});
				} catch (err) {
					let isMissingCustomerID = false;
					if (err.response.data === 'missing MAXIO_CUSTOMER_ID') {
						isMissingCustomerID = true;
					}
					this.setState({
						propertyInvoices:  [],
						fetchingError:     true,
						missingCustomerId: isMissingCustomerID,
					});
					console.error('Error fetching invoices:', err);
				}
			};

			await fetchInvoiceInfomation(this.state.selectedProperty);
		});
	}

	handleInputChange = (e) => {
		const {
			name,
			value,
		} = e.target;
		this.setState((prevState) => {
			return ({
				formData: {
					...prevState.formData,
					[name]: value,
				},
				errors: {
					...prevState.errors,
					[name]: '',
				},
			});
		});
	}

	validateForm = () => {
		const {
			company_name,
			contact,
			email,
			phone,
			addr1,
			city,
			state,
			zip_code,
		} = this.state.formData;
		const errors = {};

		if (!company_name.trim()) {
			errors.company_name = 'Company is required.';
		}

		if (!contact.trim()) {
			errors.contact = 'Contact Name is required.';
		}

		if (!addr1.trim()) {
			errors.addr1 = 'Address Line 1 is required.';
		}

		if (!email.trim()) {
			errors.email = 'Email is required.';
		} else {
			// Support multiple comma-separated emails
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			const emails = email.split(',').map(e => e.trim());
			const invalidEmails = emails.filter(e => !emailRegex.test(e));

			if (invalidEmails.length > 0) {
				errors.email = 'Please enter valid email address(es). Multiple emails should be separated by commas.';
			}
		}

		if (phone.trim()) {
			// US phone number regex:
			// Allows formats like:
			// 1234567890
			// 123-456-7890
			// (123) 456-7890
			// 123.456.7890
			// +1 (123) 456-7890
			const phoneRegex = /^(\+1\s?)?(\([0-9]{3}\)|[0-9]{3})[-.\s]?[0-9]{3}[-.\s]?[0-9]{4}$/;
			if (!phoneRegex.test(phone.trim())) {
				errors.phone = 'Please enter a valid US phone number.';
			}
		} else {
			errors.phone = 'Phone number is required.';
		}

		if (!city.trim()) {
			errors.city = 'City is required.';
		}

		if (!state.trim()) {
			errors.state = 'State is required.';
		}

		if (!zip_code.trim()) {
			errors.zip_code = 'ZIP Code is required.';
		}

		this.setState({
			errors,
		});

		return Object.keys(errors).length === 0;
	}

	handleFormSubmit = (e) => {
		e.preventDefault();
		if (this.validateForm()) {
			this.updateBillingInformation(this.state.selectedProperty);
			this.setState({ isEditing: false });
		} else {
			console.log('Form contains errors.');
		}
	}

	handleEditClick = () => {
		this.setState({ isEditing: true });
	}

	handleCancelClick = () => {
		this.setState({
			isEditing: false,
			errors:    {},
			formData:  { ...this.state.originalBillingData },
		});
	}

	formatCityStateZip = (city, state, zip) => {
		const parts = [];
		if (city) parts.push(city);
		if (state || zip) {
			const stateZip = [state, zip].filter(Boolean).join(' ');
			if (stateZip) parts.push(stateZip);
		}
		return parts.length > 0 ? parts.join(', ') : 'N/A';
	}

	renderTab = () => {
		let tabHtml = null;
		let tabHtmlContent = null;
		if (this.state.activeTab === 'billing information') {
			tabHtmlContent = (
				<>
					{(this.state.fetchingError && this.state.missingCustomerId) && (
						<div>No customer information for this property.</div>
					)}

					{/* Display current billing information in read-only mode */}
					{!this.state.fetchingError && !this.state.missingCustomerId && this.state.customerID && !this.state.isEditing && (
						<div className={style.currentBillingInfo}>
							<div className={style.billingInfoHeader}>
								<p className={style.currentBillingHeader}>
									Please review the billing information currently on file - if changes are required, please click Edit
								</p>
								<button className={style.editButton} onClick={this.handleEditClick}>Edit</button>
							</div>
							<div className={style.currentBillingDisplay}>
								<div className={style.billingRow}>
									<span className={style.billingLabel}>Company:</span>
									<span className={style.billingValue}>{this.state.originalBillingData.company_name || 'N/A'}</span>
								</div>
								<div className={style.billingRow}>
									<span className={style.billingLabel}>Contact Name:</span>
									<span className={style.billingValue}>{this.state.originalBillingData.contact || 'N/A'}</span>
								</div>
								<div className={style.billingRow}>
									<span className={style.billingLabel}>Email:</span>
									<span className={style.billingValue}>{this.state.originalBillingData.email || 'N/A'}</span>
								</div>
								<div className={style.billingRow}>
									<span className={style.billingLabel}>Phone:</span>
									<span className={style.billingValue}>{this.state.originalBillingData.phone || 'N/A'}</span>
								</div>
								<div className={style.billingRow}>
									<span className={style.billingLabel}>Address:</span>
									<span className={style.billingValue}>
										{this.state.originalBillingData.addr1 || 'N/A'}
										{this.state.originalBillingData.addr2 && `, ${this.state.originalBillingData.addr2}`}
									</span>
								</div>
								<div className={style.billingRow}>
									<span className={style.billingLabel}>City, State ZIP:</span>
									<span className={style.billingValue}>
										{this.formatCityStateZip(this.state.originalBillingData.city, this.state.originalBillingData.state, this.state.originalBillingData.zip_code)}
									</span>
								</div>
							</div>
						</div>
					)}

					{/* Show editable form when in edit mode */}
					{!this.state.fetchingError && !this.state.missingCustomerId && this.state.customerID && this.state.isEditing && (
						<form onSubmit={this.handleFormSubmit} noValidate>
							<p className={style.helpText}>Invoices can be sent to multiple email addresses - please provide all relevant email addresses separated by a comma</p>
							<div className={`${style.form} text-small`}>
								<label>
									Company<span className={style.required}> *</span>
									<input
										type="text"
										name="company_name"
										value={this.state.formData.company_name}
										onChange={this.handleInputChange}
										className={this.state.errors.company_name ? style.inputError : ''}
									/>
									{this.state.errors.company_name && <p className={style.error}>{this.state.errors.company_name}</p>}
								</label>
								<label>
									Contact Name<span className={style.required}> *</span>
									<input
										type="text"
										name="contact"
										value={this.state.formData.contact}
										onChange={this.handleInputChange}
										className={this.state.errors.contact ? style.inputError : ''}
									/>
									{this.state.errors.contact && <p className={style.error}>{this.state.errors.contact}</p>}
								</label>
								<label>
									Email<span className={style.required}> *</span>
									<input
										type="text"
										name="email"
										value={this.state.formData.email}
										onChange={this.handleInputChange}
										className={this.state.errors.email ? style.inputError : ''}
									/>
									{this.state.errors.email && <p className={style.error}>{this.state.errors.email}</p>}
								</label>
								<label>
									Phone
									<input
										type="text"
										name="phone"
										value={this.state.formData.phone}
										onChange={this.handleInputChange}
										className={this.state.errors.phone ? style.inputError : ''}
									/>
									{this.state.errors.phone && <p className={style.error}>{this.state.errors.phone}</p>}
								</label>
								<label>
									Address Line 1<span className={style.required}> *</span>
									<input
										type="text"
										name="addr1"
										value={this.state.formData.addr1}
										onChange={this.handleInputChange}
										className={this.state.errors.addr1 ? style.inputError : ''}
									/>
									{this.state.errors.addr1 && <p className={style.error}>{this.state.errors.addr1}</p>}
								</label>
								<label>
									Address Line 2
									<input
										type="text"
										name="addr2"
										value={this.state.formData.addr2}
										onChange={this.handleInputChange}
									/>
								</label>
								<div className={style.cityStateLine}>
									<label>
										City<span className={style.required}> *</span>
										<input
											type="text"
											name="city"
											value={this.state.formData.city}
											onChange={this.handleInputChange}
											className={this.state.errors.city ? style.inputError : ''}
										/>
										{this.state.errors.city && <p className={style.error}>{this.state.errors.city}</p>}
									</label>
									<label>
										State<span className={style.required}> *</span>
										<input
											type="text"
											name="state"
											value={this.state.formData.state}
											onChange={this.handleInputChange}
											className={this.state.errors.state ? style.inputError : ''}
										/>
										{this.state.errors.state && <p className={style.error}>{this.state.errors.state}</p>}
									</label>
								</div>
								<label>
									ZIP Code<span className={style.required}> *</span>
									<input
										type="text"
										name="zip_code"
										value={this.state.formData.zip_code}
										onChange={this.handleInputChange}
										className={this.state.errors.zip_code ? style.inputError : ''}
									/>
									{this.state.errors.zip_code && <p className={style.error}>{this.state.errors.zip_code}</p>}
								</label>
							</div>
							<div className={style.formButtons}>
								<button className="button" type="submit">Update Billing Information</button>
								<button className={style.cancelButton} type="button" onClick={this.handleCancelClick}>Cancel</button>
							</div>
						</form>
					)}
				</>
			);
		} else {
			tabHtmlContent = (
				<>
					{this.state.fetchingError && (
						<div>There seems to be an issue retrieving your invoices. Please refresh or come back in a bit.</div>
					)}

					{(!this.state.propertyInvoices || this.state.propertyInvoices.length === 0) && !this.state.fetchingError && (
						<div>
							<p>No invoices currently exist for this account.</p>
							<p>Invoices are available approximately 50 days in advance of their due date, so please check back during that time frame.</p>
							<p>If you have any questions or concerns, please contact our Renewals team at <a href="mailto:Renewals@touchsource.com">Renewals@touchsource.com</a>.</p>
						</div>
					)}
					<table className={style.table}>
						<thead>
							<tr>
								<th>Invoice Number</th>
								<th>Date</th>
								<th>Amount</th>
								<th>Status</th>
								<th>Action</th>
							</tr>
						</thead>
						<tbody>
							{this.state.propertyInvoices && this.state.propertyInvoices.map((invoice, index) => {
								return (
									<tr key={index}>
										<td>{invoice.number}</td>
										<td>{invoice.date}</td>
										<td>{invoice.local_amount}</td>
										<td>{invoice.is_paid ? 'Paid' : 'Not paid'}</td>
										<td>
											{invoice.einvoicing_url && (
												<button className={style.viewButton} onClick={() => {
													this.viewInvoice(invoice);
												}}>
													<CustomIcon icon='eye' color={'#4B4B4B'} /> View
												</button>
											)}
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				</>
			);
		}

		tabHtml = (<div className={style.container}>
			<div className={style.tabContainer}>
				<button onClick={(() => {
					this.changeTab('billing information');
				})} className={`${style.tab} ${this.state.activeTab === 'billing information' && style.activeTab}`}>Billing Information</button>
				<button onClick={(() => {
					this.changeTab('invoices');
				})} className={`${style.tab} ${this.state.activeTab === 'invoices' && style.activeTab}`}>Invoices</button>
			</div>
			{tabHtmlContent}
		</div>);

		return tabHtml;
	}

	viewInvoice = (invoice) => {
		if (!invoice.einvoicing_url) {
			console.error('EInvoicing URL is not available for this invoice.');
			return;
		}

		window.open(invoice.einvoicing_url, '_blank');
	};

	changeTab = (tab) => {
		this.setState({
			activeTab:  tab,
			isEditing:  false,
			errors:     {},
		});
	}

	render() {
		return (
			<React.Fragment>
				<div className={style.billingPage}>
					<div className='settings-header'>
						<h2>Billing Profile</h2>
					</div>
					<div className={style.billingContent} >
						<div className={style.label}>Property</div>
						<Select
							options={this.state.projectNumbers.map((project) => {
								return {
									value: project.projectNumber,
									label: `${project.projectNumber} - ${project.systemGroupName}`,
								};
							})}
							onChange={(e) => {
								this.setState({
									selectedProperty: e.value,
									errors:           { },
									isEditing:        false,
								});
								this.getInvoices();
								this.getBillingInformation(e.value);
							}}
						/>

						{!this.state.selectedProperty && (
							<div className={style.alertMessage}>
								Please select a property to view billing information and invoices.
							</div>
						)}

						{(this.state.selectedProperty) && (this.renderTab())}
					</div>
				</div>
			</React.Fragment>
		);
	}
}

window.CrowFormField['custom.vulture.billing'] = BillingView;
export default BillingView;
